import React, { useContext, useEffect, useState } from 'react';
import proptypes from 'prop-types';
const { func } = proptypes;

import { Button } from '@thd-olt-component-react/core-ui';
import { useNavigate } from '@thd-olt-component-react/router';

import { DenyClearVerificationApiContext } from '../../../../context/DenyClearVerificationApiContext';

import './decline-clear-modal-body.scss';

export const DeclineClearModalBody = ({ handleClose }) => {
  const { executeRequest } = useContext(DenyClearVerificationApiContext)
  const navigate = useNavigate();

  const declineClear = () => {
    executeRequest();
    navigate('/c/tool_and_truck_rental');
  }

  return (
    <div className="decline-clear-modal">
      <div className="decline-clear-modal__modal-content">
        <div className="decline-clear-modal__modal-header">
          CLEAR verification is required when renting this asset.&nbsp;
          By clicking &quot;no thanks&quot; we will not be able to proceed.
        </div>
        <div className="decline-clear-modal__modal-footer">
          <Button
            outline
            onClick={() => declineClear()}
          >
            No Thanks
          </Button>
          <Button
            onClick={() => handleClose()}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

DeclineClearModalBody.displayName = 'DeclineClearModalBody';

DeclineClearModalBody.propTypes = {
  handleClose: func.isRequired
};
